module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "detail-header"
  }, [_vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('a', {
    staticClass: "img-back white pull-left",
    staticStyle: {
      "padding-left": "15px",
      "margin-left": "0"
    },
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('router-link', {
    staticClass: "pull-right white",
    attrs: {
      "to": {
        'path': '/student/edit/' + _vm.studentId
      }
    }
  }, ["编辑"])]), " ", _vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('span', {
    staticClass: "block img-wrap big"
  }, [_vm._h('img', {
    attrs: {
      "src": _vm.info.image_address ? (_vm.info.baseAcessPath + _vm.info.image_address) : _vm.img_default,
      "width": "100%"
    }
  })]), " ", _vm._h('span', {
    staticClass: "font-16 block margin-15"
  }, [_vm._s(_vm.info.studentName)])]), _vm._h('p')]), " ", _vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["生日："]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.info.studentBirthday ? _vm.info.studentBirthday : '未填写')])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["性别："]), " ", _vm._h('i', {
    class: _vm.info.sex == '男' ? 'img-sex boy' : 'img-sex girl',
    staticStyle: {
      "float": "right"
    }
  }, [_vm._s(_vm.info.sex)])])]), " ", _vm._h('li', {
    staticClass: "list-group hide"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["编入班级："]), " ", (_vm.info.relation_className) ? _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.info.relation_className)]) : _vm._h('span', {
    staticClass: "pull-right orange"
  }, ["未编入班级"]), " "])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["托管服务:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, ["\n          " + _vm._s(_vm.info.typeName ? _vm.info.typeName : '未添加托管服务') + "\n          "])])]), " ", " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["所在学校:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s((_vm.info.szxx ? _vm.info.szxx : '') + ' ' + (_vm.info.grade ? _vm.info.grade : '未填写'))])])]), " ", (!_vm.hideInsurance) ? _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('router-link', {
    staticClass: "clearfix group-txt img-more",
    attrs: {
      "to": {
        'path': '/insurance/insurance-pdf/' + _vm.insuranceInfo[0].insure_url
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["安全保障:"]), " ", _vm._h('span', {
    staticClass: "pull-right green margin-x-15"
  }, [_vm._s(_vm.insuranceInfo[0].insure_name)])])]) : _vm._e()]), " ", _vm._h('strong', {
    staticClass: "block margin-x-15"
  }, ["关联家长"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.info.parentList), function(item) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('div', {
      staticClass: "clearfix  group-txt"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item.parentRole)]), " ", (item.djlxr == 1) ? _vm._h('span', {
      staticClass: "pull-left margin-x-15 gray"
    }, ["第一联系人"]) : _vm._e(), " ", _vm._h('a', {
      staticClass: "pull-right gray",
      attrs: {
        "href": 'tel:' + item.phoneNum
      }
    }, [_vm._s(item.phoneNum)])])])
  }), " ", (_vm.info.parentList && _vm.info.parentList.length == 0) ? [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["监护角色："]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15"
  }, [_vm._s(_vm.info.parentRole)])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["手机号码："]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15"
  }, [_vm._s(_vm.info.parentPhone)])])])] : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-3a932f60!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/student/StudentDetail.vue
// module id = 192
// module chunks = 1